import { useProductImages } from '../hooks/useProductImages';

type ThumbImgProps = {
	src: string;
};

const ThumbImg = ({ src }: ThumbImgProps) => {
	const { blockClass } = useProductImages();

	const renderClass = () => {
		return blockClass && `vtex-store-components-3-x-thumbImg--${blockClass}`;
	};

	return (
		<img
			className={`thumbImg thumbImg--${blockClass} vtex-store-components-3-x-thumbImg ${renderClass()} w-100 h-auto db`}
			alt=""
			src={src}
		/>
	);
};

export default ThumbImg;
